import { render, staticRenderFns } from "./StockConsumptionAjurNumbersList.vue?vue&type=template&id=5a2be91a&scoped=true&"
import script from "./StockConsumptionAjurNumbersList.vue?vue&type=script&lang=js&"
export * from "./StockConsumptionAjurNumbersList.vue?vue&type=script&lang=js&"
import style0 from "./StockConsumptionAjurNumbersList.vue?vue&type=style&index=0&id=5a2be91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2be91a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VOverlay,VProgressCircular,VSkeletonLoader})
